import React from "react";
import Section2Banner from "./Section2Banner";
import "./section2.css";

function Section2() {
  return (
    <div className="section2">
      <h1>
        the fastest
        <br />
        growing platform
      </h1>
      <Section2Banner />
    </div>
  );
}

export default Section2;
